module.exports = __webpack_public_path__ + "assets/img/ymqh4.29f9d961.gif";